export const settingRoutes = {
  'api.setting.multiple': 'settings/multiple',
  'api.setting.single': 'settings/single',
  'api.setting.check-ip': 'ip/check',
};
